import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupUpdateContentProps } from './msg-group-update-content';
import { MsgGroupUpdateContent } from './msg-group-update-content';

export interface MsgGroupUpdateProps extends MsgGroupUpdateContentProps {}

export const MsgGroupUpdate = memo(function MsgGroupUpdate({ message }: MsgGroupUpdateProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupUpdateContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
